import React, { useEffect, useMemo, useState } from 'react';
import ProductCard from '../Components/ProductCards/ProductCard';
import type Product from '../Types/Product';
import {} from 'swiper/react';
import { LinkModel } from '../Types/LinkModel';
import CustomResponsiveSlider from '../Components/CustomResponsiveSlider/CustomResponsiveSlider';
import { getBlockData } from '../Services/Block.service';
import ProductCardPlaceholder from '../Components/ProductCards/ProductCardPlaceholder';

export interface ProductBlockSharedProps {
  preTitle?: string;
  title?: string;
  link?: LinkModel;
  numPerRow: number;
  showSlider: boolean;
  mobileLayout?: 'small' | 'large';
  products?: Product[];
}

export interface ProductBlockComponentProps extends ProductBlockProps {
  numberOfProducts: number;
  blockSystemId?: string;
}

export interface ProductBlockProps extends ProductBlockSharedProps {
  showProductInfo: boolean;
  showRoomImage: boolean;
  showPatternImage: boolean;
}

const ProductBlock = ({
  blockSystemId,
  numberOfProducts,
  title,
  preTitle,
  link,
  numPerRow,
  showSlider,
  mobileLayout = 'small',
  ...props
}: ProductBlockComponentProps) => {
  const [blockProps, setBlockProps] = useState<
    ProductBlockProps | undefined
  >();

  const showProductInfo = useMemo(
    () => blockProps?.showProductInfo ?? props.showProductInfo,
    [blockProps?.showProductInfo, props.showProductInfo]
  );
  const showRoomImage = useMemo(
    () => blockProps?.showRoomImage ?? props.showRoomImage,
    [blockProps?.showRoomImage, props.showRoomImage]
  );

  const items = useMemo(
    () =>
      blockProps?.products
        ? blockProps.products
        : props.products ?? Array.from({ length: numberOfProducts }),
    [blockProps?.products, numberOfProducts, props.products]
  );

  useEffect(() => {
    const getPageCardBlock = async () => {
      setBlockProps(await getBlockData('ProductBlock', blockSystemId!));
    };

    if (!props.products && !blockProps && blockSystemId) {
      getPageCardBlock();
    }
  }, [blockSystemId]);

  return (
    <>
      <CustomResponsiveSlider
        items={items}
        preTitle={preTitle}
        title={title}
        numPerRow={numPerRow}
        showSlider={showSlider}
        mobileLayout={mobileLayout}
        link={link}
        swiperSlideClassName="rounded"
        itemRenderer={(item, key, className) =>
          blockProps?.products ?? props.products ? (
            <ProductCard
              key={key}
              product={item}
              className={className}
              showInfo={showProductInfo}
              showRoomshot={showRoomImage}
              showPatternImage={!showRoomImage}
              disableImageSlider={true}
            />
          ) : (
            <ProductCardPlaceholder key={key} className={className} />
          )
        }
      />
    </>
  );
};

export default ProductBlock;
